module.exports = __webpack_public_path__ + "static/media/logo.636a8a0a.svg";